import AppLogin from '../components/AppLogin.js';
import AdminLogin from '../components/AdminLogin.js';
import AdminSignup from '../components/AdminSignup.js';
import AdminPasswordReset from '../components/AdminPasswordReset.js';
import AdminForgotPassword from '../components/AdminForgotPassword.js';
import Four0four from '../components/404.js';

const routes = [{
  path: '/',
  component: AppLogin,
  children: [{
      name: 'login',
      path: '/',
      component: AdminLogin
    },
    {
      name: 'signup',
      path: '/signup',
      component: AdminSignup
    },
    {
      name: 'passwordReset',
      path: '/password-reset/:token?',
      component: AdminPasswordReset
    },
    {
      name: 'forgotPassword',
      path: '/forgot-password',
      component: AdminForgotPassword
    }
  ]
},
{
  path: '/404',
  alias: '*',
  component: Four0four
}
];

export default routes;
